import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__en-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Lemonade FR: Terms of Service',
    metaTitle: 'Lemonade FR: Terms of Service',
    description:
      'Read Lemonade’s Terms of Service for France to understand user obligations and the conditions for accessing and using our insurance platform.',
  },
  MDXContent: content as DocumentTypes,
};
